// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"624":"e40f0d7ff3c8285e84df","992":"a29ce42e938ed01bd2a9"}[chunkId] + ".chunk.js";
};